module.exports = __webpack_public_path__ + "static/media/InstitutoDeSaude.0833dde7.png";